import { useMemo } from 'react';
import { usePicklistEditor } from './usePicklist';

type ActivePicklistState = Readonly<{
  hasActivePicklist: boolean;
  isActivePicklistMatch: boolean;
  activePicklistId: string | null;
}>;

/**
 * Shared helper for consumers that need a consistent "active picklist" signal.
 * This keeps drawer/popup behavior aligned on the same core identity check.
 */
export const useActivePicklistState = (picklistID?: string): ActivePicklistState => {
  const { activePicklist } = usePicklistEditor();

  return useMemo(() => {
    const activePicklistId = activePicklist?.id ?? null;
    const hasActivePicklist = activePicklistId != null;
    const isActivePicklistMatch =
      picklistID == null
        ? hasActivePicklist
        : activePicklistId != null && activePicklistId === picklistID;

    return {
      hasActivePicklist,
      isActivePicklistMatch,
      activePicklistId,
    };
  }, [activePicklist?.id, picklistID]);
};
